// libraries
import { bridgeUserActionTypes } from '@makemydeal/dr-shared-store';
import type { ReduxNext, ReduxStore } from '@makemydeal/dr-shared-store';
import { offerSessionUtils } from '@makemydeal/dr-shared-ui-utils';
import { sessionExpired } from '@makemydeal/dr-sales-checkin-store';
import type { SessionExpiredStateTree } from '@makemydeal/dr-sales-checkin-store';

// consts/enums
import { EXPIRED_SESSION_STATUSES } from '../constants/sessionExpiredConstants';

// interfaces/types
import type { BridgeUserFailureAction } from '../types/sessionExpired.types';

export const embeddedSessionExpiredMiddleware =
    (store: ReduxStore<SessionExpiredStateTree>) => (next: ReduxNext) => (action: BridgeUserFailureAction) => {
        next(action);

        if (action.type !== bridgeUserActionTypes.BRIDGE_USER_FAILURE || !offerSessionUtils.isCrmEmbeddedMode()) {
            return;
        }

        const status = action.payload?.status;
        const trigger = status === undefined ? undefined : EXPIRED_SESSION_STATUSES[status];
        if (trigger) {
            store.dispatch(sessionExpired(trigger));
        }
    };
